import { render, staticRenderFns } from "./ListPanelTopTen.vue?vue&type=template&id=585c2809&scoped=true&"
import script from "./ListPanelTopTen.vue?vue&type=script&lang=js&"
export * from "./ListPanelTopTen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585c2809",
  null
  
)

export default component.exports